import { ApiService } from "../../constants/ApiService";
import { HttpService } from "../../constants/HTTPService";
import { IDataUploadPreview } from "../../interfaces/IDataUploadPreview";

export const uploadPreview = async (payload: IDataUploadPreview) => {
  const dataAPI = await HttpService.post(
    ApiService.alesaForm.uploadPreview,
    JSON.stringify({
      FileName: payload.fileName,
      FileBase64: payload.fileBase64,
    })
  );

  return dataAPI.data.data;
};

export const deletePreview = async (fileName: string) => {
  const dataAPI = await HttpService.post(
    `${ApiService.alesaForm.deletePreview}/${fileName}`,
    null
  );

  return dataAPI.data.data;
};
